import { OverlayModule } from '@angular/cdk/overlay';
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { APP_INITIALIZER, InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppConfigService } from '@app/app-config.service';
import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { AppStore } from '@app/app.store';
import { ContentContainerStore } from '@app/core/containers/content-container/store/content-container.store';
import { CoreModule } from '@app/core/core.module';
import { CacheInterceptor } from '@app/core/interceptors/cache.interceptor';
import { DivisionInterceptor } from '@app/core/interceptors/division.interceptor';
import { TokenInterceptor } from '@app/core/interceptors/token.interceptor';
import { VisibilityIncerceptor } from '@app/core/interceptors/visibility.interceptor';
import { LoginServiceImpl } from '@app/features/auth/services/impl/login.service.impl';
import { LoginStateServiceImpl } from '@app/features/auth/services/impl/login.state.service.impl';
import { SharedModule } from '@app/shared/shared.module';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { NgxPermissionsModule } from 'ngx-permissions';
import { environment } from 'src/environments/environment';
import { StateFactoryService } from './core/services/state/state-factory.service';
import { TranslationService } from './core/services/translate/translate.service';
import { LoginSamlServiceImpl } from './features/auth/services/impl/login.saml.service.impl';

export function initializeApp(appConfigService: AppConfigService, transl: TranslateService) {
  return () => appConfigService.load(transl);
}

export function getJwtDecoder() {
  return new JwtHelperService();
}

export const WINDOW = new InjectionToken('window', { providedIn: 'root', factory: () => window });

registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [AppComponent],
  imports: [
    // Angular
    BrowserModule,
    OverlayModule,
    // 3rd Party
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationService,
        deps: [HttpClient, AppConfigService]
      }
    }),
    NgxPermissionsModule.forRoot(),
    NgxMaskModule.forRoot(),
    // Core
    CoreModule,
    SharedModule,
    // App
    AppRoutingModule,
    BrowserAnimationsModule
  ],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService, TranslateService],
      multi: true
    },
    {
      provide: APP_BASE_HREF,
      useValue: environment.baseHref
    },
    {
      provide: StateFactoryService,
      useClass: StateFactoryService
    },
    {
      provide: JwtHelperService,
      useFactory: getJwtDecoder
    },
    {
      provide: AppStore,
      useClass: AppStore
    },
    {
      provide: 'ContentContainerStore',
      useClass: ContentContainerStore
    },
    {
      provide: 'LoginService',
      useClass: LoginServiceImpl
    },
    {
      provide: 'LoginSamlService',
      useClass: LoginSamlServiceImpl
    },
    {
      provide: 'LoginStateService',
      useClass: LoginStateServiceImpl
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DivisionInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: VisibilityIncerceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
